import { render, staticRenderFns } from "./EntradaChats.vue?vue&type=template&id=4bfffbb6"
import script from "./EntradaChats.vue?vue&type=script&lang=js"
export * from "./EntradaChats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports